var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Mietvertrag"}},[_c('contract-lagermeister',{attrs:{"offer":_vm.theOffer}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }